import api from './apiLibrary';

const API = {
    getUserChanges(params) {
        return api.get('/api/admin/user/changes', params);
    },
    getUserChange(id) {
        return api.get(`/api/admin/user/changes/${id}`);
    },
};

export default API;
